import { useMemo } from 'react';

function getLevelCss(level = '1') {
    switch (level) {
        case '2':
            return 'text-3xl sm:text-5xl leading-tight';
        case '3':
            return 'text-3xl sm:text-4xl leading-tight';
        case '4':
            return 'text-2xl sm:text-3xl leading-tight';
        case '5':
            return 'text-lg';
        case '6':
            return '';
        default:
            return 'text-4xl sm:text-5xl lg:text-6xl xl:text-8xl lg:leading-none';
    }
}
const useHeadingStyles = (level) => {
    const styles = useMemo(() => {
        return ['font-heading', getLevelCss(level)].join(' ');
    }, [level]);
    return styles;
};

export { useHeadingStyles };
//# sourceMappingURL=useHeadingStyles.js.map
